exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ReadMore__container___1-H3a {\n  margin-bottom: 38px;\n  line-height: 1.63;\n  font-size: 16px; }\n  @media (max-width: 576px) {\n    .ReadMore__container___1-H3a {\n      margin-top: 38px; } }\n  .ReadMore__container___1-H3a .ReadMore__link___2Kv2y {\n    text-decoration: underline;\n    word-break: break-all; }\n  .ReadMore__container___1-H3a .ReadMore__readMoreBtn___2E4eS {\n    margin-left: 4px;\n    font-weight: 800; }\n", ""]);

// exports
exports.locals = {
	"container": "ReadMore__container___1-H3a",
	"link": "ReadMore__link___2Kv2y",
	"readMoreBtn": "ReadMore__readMoreBtn___2E4eS"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/ReadMore/ReadMore.scss
// module id = 4920
// module chunks = 6